import { useMemo, useState } from "react";
import ContentList from "../../../customUiForCs/ContentList";
import SiteCard from "../sites/SiteCard";
import ZoneDropDownInput from "../sites/ZoneDropDownInput";

export default function NomenclatureOfSite({
  columns = 1,
  initialZoneID,
  disableZoneFilter,
  disableFilters,
  inheritedSearchQuery,
  buttons,
}) {
  const [zoneID, setZoneID] = useState(initialZoneID ? initialZoneID : null);

  const queryParams = useMemo(
    () => ({
      zoneID,
    }),
    [zoneID]
  );

  return (
    <ContentList
      buttons={buttons}
      disableFilters={disableFilters}
      inheritedSearchQuery={inheritedSearchQuery}
      //
      columns={columns}
      permissionName={"sitePermissions"}
      queryParams={queryParams}
      filters={
        disableZoneFilter ? (
          false
        ) : (
          <ZoneDropDownInput onChange={setZoneID} value={zoneID} label="Zone" />
        )
      }
      title="Sites"
      path="sites"
      CardComponent={SiteCard}
    />
  );
}
